import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './context/AuthContext';
import { CountryProvider } from './context/CountryContext';
import HomePage from './pages/HomePage';
import ReviewCardsPage from './pages/ReviewCardsPage';
import DigitalCardsPage from './pages/DigitalCardsPage';
import CategoryCardsPage from './pages/CategoryCardsPage';
import DigitalCardCustomizationPage from './pages/DigitalCardCustomizationPage';
import EnterprisePage from './pages/EnterprisePage';
import ArtistPage from './pages/ArtistPage';
import ShopPage from './pages/ShopPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import CheckoutPage from './pages/CheckoutPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import DigitalCardProfile from './pages/DigitalCardProfile';
import ScrollToTop from './components/ScrollToTop';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminOrders from './pages/admin/AdminOrders';
import OrderDetailsPage from './pages/admin/OrderDetailsPage';
import TagsPage from './pages/admin/TagsPage';
import CategoriesPage from './pages/admin/CategoriesPage';
import MaterialsPage from './pages/admin/MaterialsPage';
import CardTypesPage from './pages/admin/CardTypesPage';
import CardCategoriesPage from './pages/admin/CardCategoriesPage';
import ColoursPage from './pages/admin/ColoursPage';
import CountriesPage from './pages/admin/CountriesPage';
import DynamicLinksPage from './pages/admin/DynamicLinksPage';
import CouponsPage from './pages/admin/CouponsPage';
import BusinessCardsPage from './pages/admin/BusinessCardsPage';
import AdminDigitalCardsPage from './pages/admin/DigitalCardsPage';
import ReviewCardsNewPage from './pages/admin/ReviewCardsNewPage';
import ReviewStandeesManagementPage from './pages/admin/ReviewStandeesManagementPage';
import ArtistsPage from './pages/admin/ArtistsPage';
import ShippingChargesPage from './pages/admin/ShippingChargesPage';
import UsersPage from './pages/admin/UsersPage';
import LoginLogsPage from './pages/admin/LoginLogsPage';
import UserDashboard from './pages/user/UserDashboard';
import UserOrders from './pages/user/UserOrders';
import UserOrderDetails from './pages/user/UserOrderDetails';
import UserCards from './pages/user/UserCards';
import UserDigitalCards from './pages/user/UserDigitalCards';
import UserReviewCards from './pages/user/UserReviewCards';
import UserReviewStandees from './pages/user/UserReviewStandees';
import ScanHistory from './pages/user/ScanHistory';
import UserDigitalCardConfigure from './pages/user/UserDigitalCardConfigure';
import UserDigitalCardAnalytics from './pages/user/UserDigitalCardAnalytics';
import UserDigitalProfiles from './pages/user/UserDigitalProfiles';
import UserDigitalProfileForm from './pages/user/UserDigitalProfileForm';
import ArtistLogin from './pages/artist/ArtistLogin';
import ArtistDashboard from './pages/artist/ArtistDashboard';
import ArtistCards from './pages/artist/ArtistCards';
import ArtistOrders from './pages/artist/ArtistOrders';
import CardRequestsPage from './pages/admin/CardRequestsPage';
import ArtistProfilePage from './pages/ArtistProfilePage';
import DynamicLinkRedirect from './pages/DynamicLinkRedirect';
import FAQPage from './pages/FAQPage';
import TermsPage from './pages/TermsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';

function App() {
  return (
    <AuthProvider>
      <CountryProvider>
        <div className="App min-h-screen bg-white">
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
            {/* Dynamic Link Redirect - must be before other routes */}
            <Route path="/link/:code" element={<DynamicLinkRedirect />} />
            
            <Route path="/" element={<HomePage />} />
            <Route path="/digital-cards" element={<DigitalCardsPage />} />
            <Route path="/digital-cards/category/:categoryId" element={<CategoryCardsPage />} />
            <Route path="/customize-card/:cardId" element={<DigitalCardCustomizationPage />} />
            <Route path="/review-cards" element={<ReviewCardsPage />} />
            <Route path="/enterprise" element={<EnterprisePage />} />
            <Route path="/artist" element={<ArtistPage />} />
            <Route path="/artist/:artistId" element={<ArtistProfilePage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/payment-success" element={<PaymentSuccessPage />} />
            
            {/* Public Profile Routes */}
            <Route path="/profile/:username" element={<DigitalCardProfile />} />
            <Route path="/api/profile/:username" element={<DigitalCardProfile />} />
            
            {/* User Routes */}
            <Route path="/user/dashboard" element={<UserDashboard />} />
            <Route path="/user/orders" element={<UserOrders />} />
            <Route path="/user/orders/:orderId" element={<UserOrderDetails />} />
            <Route path="/user/cards" element={<UserCards />} />
            <Route path="/user/digital-profiles" element={<UserDigitalProfiles />} />
            <Route path="/user/digital-profiles/create" element={<UserDigitalProfileForm />} />
            <Route path="/user/digital-profiles/edit/:profileId" element={<UserDigitalProfileForm />} />
            <Route path="/user/digital-cards" element={<UserDigitalCards />} />
            <Route path="/user/digital-cards/:orderId/configure" element={<UserDigitalCardConfigure />} />
            <Route path="/user/digital-cards/:cardId/analytics" element={<UserDigitalCardAnalytics />} />
            <Route path="/user/review-cards" element={<UserReviewCards />} />
            <Route path="/user/review-standees" element={<UserReviewStandees />} />
            <Route path="/user/scan-history/:linkCode" element={<ScanHistory />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/tags" element={<TagsPage />} />
            <Route path="/admin/categories" element={<CategoriesPage />} />
            <Route path="/admin/materials" element={<MaterialsPage />} />
            <Route path="/admin/card-types" element={<CardTypesPage />} />
            <Route path="/admin/card-categories" element={<CardCategoriesPage />} />
            <Route path="/admin/colours" element={<ColoursPage />} />
            <Route path="/admin/countries" element={<CountriesPage />} />
            <Route path="/admin/dynamic-links" element={<DynamicLinksPage />} />
            <Route path="/admin/coupons" element={<CouponsPage />} />
            <Route path="/admin/business-cards" element={<BusinessCardsPage />} />
            <Route path="/admin/cards" element={<AdminDigitalCardsPage />} />
            <Route path="/admin/review-cards-new" element={<ReviewCardsNewPage />} />
            <Route path="/admin/review-standees" element={<ReviewStandeesManagementPage />} />
            <Route path="/admin/artists" element={<ArtistsPage />} />
            <Route path="/admin/card-requests" element={<CardRequestsPage />} />
            <Route path="/admin/orders" element={<AdminOrders />} />
            <Route path="/admin/users" element={<UsersPage />} />
            <Route path="/admin/login-logs" element={<LoginLogsPage />} />
            <Route path="/admin/orders/:orderId" element={<OrderDetailsPage />} />
            <Route path="/admin/shipping-charges" element={<ShippingChargesPage />} />
            
            {/* Artist Routes */}
            <Route path="/artist/login" element={<ArtistLogin />} />
            <Route path="/artist/dashboard" element={<ArtistDashboard />} />
            <Route path="/artist/cards" element={<ArtistCards />} />
            <Route path="/artist/orders" element={<ArtistOrders />} />
            
            {/* Catch-all for short dynamic links - MUST BE LAST */}
            <Route path="/:code" element={<DynamicLinkRedirect />} />
          </Routes>
        </BrowserRouter>
      </div>
      </CountryProvider>
    </AuthProvider>
  );
}

export default App;
